/*** IMPORTS FROM imports-loader ***/
var jquery = require("jquery");
var moment = require("moment");

'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @jzetlen
 * Create a root renderer that will bind a provided React component to the DOM.
 * Binds the component to the local versions of React and React-DOM,
 * and saves you from having to add JSX build steps to a non-React app
 * using this.
 */

module.exports = function createRenderer(Component, container) {
	return {
		render: function render(props) {
			_reactDom2.default.render(_react2.default.createElement(Component, props), container);
		},
		remove: function remove() {
			_reactDom2.default.unmountComponentAtNode(container);
		}
	};
};



//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/component-datepicker/dist/create-renderer.js
// module id = 779
// module chunks = 0